import {
  activateCampaignEpic,
  activateCampaignObservable,
} from './activateCampaign'
import {
  createAdCreativeTemplateEpic,
  createAdCreativeTemplateObservable,
} from './createAdCreativeTemplate'
import {
  updateAdCreativeTemplateEpic,
  updateAdCreativeTemplateObservable,
} from './updateAdCreativeTemplate'
import {
  createAdSetTemplateEpic,
  createAdSetTemplateObservable,
} from './createAdSetTemplate'
import {
  updateAdSetTemplateEpic,
  updateAdSetTemplateObservable,
} from './updateAdSetTemplate'
import {
  createAdTemplateEpic,
  createAdTemplateObservable,
} from './createAdTemplate'
import {
  getAdSetTemplateEpic,
  getAdSetTemplateObservable,
} from './getAdSetTemplate'
import {
  getCallsToActionEpic,
  getCallsToActionObservable,
} from './getCallsToAction'
import {
  getChannelCampaignEpic,
  getChannelCampaignObservable,
} from './getChannelCampaign'
import {
  getAdCreativeTemplatePreviewEpic,
  getAdCreativeTemplatePreviewObservable,
} from './getAdCreativeTemplatePreview'
import {
  postAdCreativeTemplatePreviewEpic,
  postAdCreativeTemplatePreviewObservable,
} from './postAdCreativeTemplatePreview'
import {
  getRetailerAdCreativeTemplateEpic,
  getRetailerAdCreativeTemplateObservable,
} from './getAdCreativeTemplate'

import { getTargetingEpic, getTargetingObservable } from './getTargeting'

import { createAdVideoEpic, createAdVideoObservable } from './createAdVideo'
import { getAdVideoEpic, getAdVideoObservable } from './getAdVideo'
import {
  pusherTimer,
  unsubscribeFromAdVideoChannel,
  handleVideoUploadComplete,
  subscribeToAdVideo,
} from './adVideoPusherEvents'

export const observables = {
  activateCampaignObservable,
  createAdCreativeTemplateObservable,
  createAdVideoObservable,
  updateAdCreativeTemplateObservable,
  createAdSetTemplateObservable,
  updateAdSetTemplateObservable,
  createAdTemplateObservable,
  getAdSetTemplateObservable,
  getAdVideoObservable,
  getCallsToActionObservable,
  getChannelCampaignObservable,
  getAdCreativeTemplatePreviewObservable,
  postAdCreativeTemplatePreviewObservable,
  getTargetingObservable,
  getRetailerAdCreativeTemplateObservable,
}

export default {
  activateCampaignEpic,
  createAdCreativeTemplateEpic,
  createAdVideoEpic,
  updateAdCreativeTemplateEpic,
  createAdSetTemplateEpic,
  updateAdSetTemplateEpic,
  createAdTemplateEpic,
  getAdSetTemplateEpic,
  getAdVideoEpic,
  getCallsToActionEpic,
  getChannelCampaignEpic,
  getAdCreativeTemplatePreviewEpic,
  postAdCreativeTemplatePreviewEpic,
  getTargetingEpic,
  pusherTimer,
  unsubscribeFromAdVideoChannel,
  handleVideoUploadComplete,
  subscribeToAdVideo,
  getRetailerAdCreativeTemplateEpic,
}
